module.exports = __webpack_public_path__ + "img/iconSystemDepartment.24ea6bf3.svg";